import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

export default function CommunityTabs() {
  const [value, setValue] = React.useState(2);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Tabs value={value} onChange={handleChange} aria-label="ant example">
      <Tab label="Dashboard" className="extraClass" />
      <Tab label="Daily Planning" />
      <Tab label="Planning" />
      <Tab label="Visit Actuals" />
      <Tab label="Reports" />
      <Tab label="Patients" />
      <Tab label="Non-Patient Activities" />
      <Tab label="Admin" />
    </Tabs>
  );
}
